const boxes = document.querySelectorAll(".promo-boxes__box");
boxes.forEach(box => {
    box.addEventListener("mouseenter", boxMoveUp);
    box.addEventListener("mouseleave", boxMoveDown);
})

function boxMoveUp(e) {
    let height = window.getComputedStyle(e.target.querySelector('.promo-boxes__small-text').firstElementChild).getPropertyValue('height');
    e.target.querySelector('.promo-boxes__small-text').style.height = height;
}

function boxMoveDown(e) {
    e.target.querySelector('.promo-boxes__small-text').style.height = "";
}
